export const flexDirectionClasses = {
    horizontal: 'flex-row',
    vertical: 'flex-col',
    'horizontal-reverse': 'flex-row-reverse',
    'vertical-reverse': 'flex-col-reverse',
};
